import React from 'react';
import PropTypes from 'prop-types';
import Graphic from 'q3-ui-assets';
import Grid from '@material-ui/core/Grid';
import ProductCard, { CardColumn } from '../productCard';

const ProductResults = ({ list }) =>
  Array.isArray(list) && list.length ? (
    list.map((l) => (
      <CardColumn key={l.id}>
        <ProductCard {...l} />
      </CardColumn>
    ))
  ) : (
    <Grid item xs>
      <Graphic title="noResults" icon="NoResults" />
    </Grid>
  );

ProductResults.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      sku: PropTypes.string,
    }),
  ),
};

ProductResults.defaultProps = {
  list: [],
};

export default ProductResults;
